import { NavLink } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import dayjs from "utils/dayjs";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import MainCard from "components/MainCard";
import { useEnumApi } from "contexts/EnumApiContext";
import { fromServerFormat } from "components/date_picker/dateUtils";
import { makeFaultsMessage2 } from "data/data";

const AlertListCard = ({equipmentAlerts, target='md', height="330px"}) => {
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    return (
        <div style={{width:"100%"}}>
            <MainCard className="center_table" style={{width:"100%"}} content={false}>
                <TableContainer style={{width:"100%", height:height, overflowY:"auto"}}>
                <Table aria-label="simple table" className="base_link" style={{width:"100%", minWidth:'500px', borderCollapse:"collapse"}}>
                    <TableHead>
                    <TableRow>
                        <TableCell style={{width:'85px'}}>{t('message.common.subtitle.date')}</TableCell>
                        {(target === 'md' && platformServer !== 'NANTONG') && 
                            <TableCell align="center" style={{width:'150px'}}>{t('message.common.subtitle.zone')}</TableCell>
                            // <TableCell align="center" style={{width:'150px'}}>{getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}({t('message.common.subtitle.zone')})</TableCell>
                        }
                        {platformServer === 'NANTONG' &&
                            (target === 'md' ? 
                            <TableCell align="center">{t('message.common.subtitle.station')}</TableCell>
                            : <TableCell align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>)
                        }
                        <TableCell align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                        {/* <TableCell align="center">{t('message.common.subtitle.alertType')}</TableCell> */}
                        <TableCell align="center" style={{width:'75px'}}>{t('message.common.subtitle.alertCategory')}</TableCell>
                        <TableCell align="center" style={{width:'75px'}}>{t('message.common.subtitle.status')}</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {equipmentAlerts ? equipmentAlerts.map((alert, i) => {
                        let linkUrl = "/equipment-alert-history-tracking/"+alert.id;
                        let statusClassName = '';
                        if (alert.status) {
                            if (alert.status === 'D') {
                                statusClassName = 'condition1';
                            } else if (alert.status === 'F') {
                                statusClassName = 'condition2';
                            } else if (alert.status === 'M') {
                                if (alert.fllwActionType) {
                                    if (alert.fllwActionType === 'O1_WAIT')
                                        statusClassName = 'condition1';
                                    else if (alert.fllwActionType === 'O2_OBSERVE')
                                        statusClassName = 'condition2';
                                    else if (alert.fllwActionType === 'O3_MNT')
                                        statusClassName = 'condition5';
                                    else if (alert.fllwActionType === 'O4_NORMAL')
                                        statusClassName = 'condition6';
                                }
                            }
                        }

                        let alertDtl = (alert.alertDtl ?? '');
                        alertDtl += makeFaultsMessage2(alert, getEnumValueByEnumNameAndCode);
                        
                        let managementCompanyAndZone = '';
                        if (target === 'md' && platformServer !== 'NANTONG') {
                            if (alert.equipment?.managementCompany?.info?.name === alert.equipment?.zone?.name)
                                managementCompanyAndZone = alert.equipment?.managementCompany?.info?.name
                            else
                                managementCompanyAndZone = alert.equipment?.managementCompany?.info?.name+'('+alert.equipment?.zone?.name+')';
                        }
                        return (
                        <TableRow hover key={i} style={{verticalAlign:"top"}}>
                            <TableCell align="center"><NavLink href={linkUrl}>{alert.latestAlertedAt && fromServerFormat(alert.latestAlertedAt, {format : t('message.common.text.date.format.date')})}</NavLink></TableCell>
                            {(target === 'md' && platformServer !== 'NANTONG') && 
                                <TableCell align="center"><NavLink href={linkUrl}>{managementCompanyAndZone ?? ''}</NavLink></TableCell>
                            }
                            {platformServer === 'NANTONG' && 
                                (target === 'md' ? 
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.equipment?.zone?.name ?? ''}</NavLink></TableCell>
                                : <TableCell align="center"><NavLink href={linkUrl}>{alert.equipment?.equipmentCtgr?.parent?.parent?.name ?? ''}</NavLink></TableCell>)
                            }
                            <TableCell align="center"><NavLink href={linkUrl}>{alert.equipment?.name ?? ''}</NavLink></TableCell>
                            {/* <TableCell align="center"><NavLink href={linkUrl}>{alert.alertType && getEnumValueByEnumNameAndCode("AlertType", alert.alertType)?.[0]?.title}</NavLink></TableCell> */}
                            <TableCell align="center"><NavLink href={linkUrl}>{alert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory)?.[0]?.title}</NavLink></TableCell>
                            <TableCell align="center">
                                <NavLink href={linkUrl}>
                                    <div className={alert.status === 'D' ? 'condition1' : alert.status === 'F' ? 'condition2' : alert.status === 'M' ? 'condition4' : ''}>
                                        {alert.alertCategory && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", alert.status)?.[0]?.title}
                                    </div>
                                </NavLink>
                            </TableCell>
                        </TableRow>
                    )
                    })
                    :
                    <TableRow hover style={{verticalAlign:"top"}}>
                        <TableCell align="center" colSpan={(platformServer === 'YIHAI' && target === 'sd') ? 4 : 5}>&nbsp;</TableCell>
                    </TableRow>
                    }
                    </TableBody>
                </Table>
                </TableContainer>
            </MainCard>
        </div>
    )
}

export default AlertListCard;